import { SUPPORTED_LANGUAGES } from "../../../i18n";

/** A language the help is written in: the app's languages. */
export type HelpLanguage = (typeof SUPPORTED_LANGUAGES)[number];

/** The help's language for the app's current one; English when it is neither. */
export function helpLanguageOf(appLanguage: string | undefined): HelpLanguage {
  return SUPPORTED_LANGUAGES.find((language) => appLanguage?.startsWith(language)) ?? "en";
}
